"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.intersection = exports.Dictionary = exports.Array = exports.Boolean = exports.Number = exports.Integer = exports.StringEnum = exports.String = exports.Required = exports.WithConstraint = exports.WithDefault = exports.Optional = void 0;
var typed_primitives_1 = require("@sixfold/typed-primitives");
var Optional = function (inner) { return ({
    typeName: "optional ".concat(inner.typeName),
    parse: function (name, serialized) {
        return serialized === undefined ? undefined : inner.parse(name, serialized);
    },
    serialize: function (value) {
        return value === undefined ? undefined : inner.serialize(value);
    }
}); };
exports.Optional = Optional;
var WithDefault = function (inner, defaultValue) { return ({
    typeName: "withDefault ".concat(inner.typeName),
    parse: function (name, serialized) {
        return serialized === undefined ? defaultValue : inner.parse(name, serialized);
    },
    serialize: function (value) {
        return value === defaultValue ? undefined : inner.serialize(value);
    }
}); };
exports.WithDefault = WithDefault;
var WithConstraint = function (inner, constraint) { return ({
    typeName: "withConstraint ".concat(inner.typeName),
    parse: function (name, serialized) {
        var parsedValue = serialized === undefined ? undefined : inner.parse(name, serialized);
        if (parsedValue === undefined) {
            throw new Error("".concat(name, ": Required variable not provided"));
        }
        if (!constraint(parsedValue)) {
            throw new Error("".concat(name, ": Failed constraint check"));
        }
        return parsedValue;
    },
    serialize: function (value) {
        return value === undefined ? undefined : inner.serialize(value);
    }
}); };
exports.WithConstraint = WithConstraint;
var Required = function (inner) { return ({
    typeName: inner.typeName,
    parse: function (name, serialized) {
        if (serialized === undefined) {
            throw new Error("".concat(name, ": Required variable not provided"));
        }
        return inner.parse(name, serialized);
    },
    serialize: function (value) {
        return inner.serialize(value);
    }
}); };
exports.Required = Required;
var buildRequiredVariable = function (variable) { return (__assign(__assign({}, variable), { required: (0, exports.Required)(variable), optional: (0, exports.Optional)(variable), withDefault: function (defaultValue) { return (0, exports.WithDefault)(variable, defaultValue); }, withConstraint: function (constraint) { return (0, exports.WithConstraint)(variable, constraint); } })); };
// tslint:disable-next-line:variable-name
exports.String = buildRequiredVariable({
    typeName: 'string',
    parse: function (_name, serialized) {
        return serialized;
    },
    serialize: function (value) {
        return value;
    }
});
var StringEnum = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var allowedValues = values.map(function (value) { return "\"".concat(value, "\""); }).join(' | ');
    return buildRequiredVariable({
        typeName: allowedValues,
        parse: function (_name, serialized) {
            var value = values.find(function (providedValue) { return serialized === providedValue; });
            if (value === undefined) {
                throw new Error("\"".concat(serialized, "\" does not belong in ").concat(allowedValues));
            }
            return value;
        },
        serialize: function (value) {
            return value;
        }
    });
};
exports.StringEnum = StringEnum;
// Util function for normalising a string to account for some values that
// are reasonable to use in numbers, but confuse parseFloat/parseInt
// Examples: 123_000 -> 123000, 123,000 -> 123000
var normaliseNumericString = function (value) { return value.replace(/_|,/g, ''); };
exports.Integer = buildRequiredVariable({
    typeName: 'integer',
    parse: function (name, serialized) {
        var normalisedInput = normaliseNumericString(serialized);
        var result = Number(normalisedInput);
        if (isNaN(result) || !Number.isInteger(result)) {
            throw new Error("".concat(name, ": '").concat(serialized, "' is not an integer"));
        }
        return result;
    },
    serialize: function (value) {
        return value.toString();
    }
});
// tslint:disable-next-line:variable-name
var NumberVariable = buildRequiredVariable({
    typeName: 'number',
    parse: function (name, serialized) {
        var normalisedInput = normaliseNumericString(serialized);
        var result = Number(normalisedInput);
        if (isNaN(result)) {
            throw new Error("".concat(name, ": '").concat(serialized, "' is not a number"));
        }
        return result;
    },
    serialize: function (value) {
        return value.toString();
    }
});
exports.Number = NumberVariable;
// tslint:disable-next-line:variable-name
exports.Boolean = buildRequiredVariable({
    typeName: 'boolean',
    parse: function (name, serialized) {
        if (serialized === 'true') {
            return true;
        }
        if (serialized === 'false') {
            return false;
        }
        throw new Error("".concat(name, ": '").concat(serialized, "' is not a boolean"));
    },
    serialize: function (value) {
        return value.toString();
    }
});
var Array = function (type) {
    return buildRequiredVariable({
        typeName: "".concat(type.typeName, "[]"),
        parse: function (name, serialized) {
            return serialized.split(',').map(function (item) { return type.parse(name, item); });
        },
        serialize: function (values) {
            return values.map(function (value) { return type.serialize(value); }).join(',');
        }
    });
};
exports.Array = Array;
var Dictionary = function (definition) { return ({
    definition: definition,
    parse: function (stringDictionary) {
        return (0, typed_primitives_1.objectMap)(definition, function (key, variable) {
            var serializedValue = stringDictionary[key];
            var parsedValue = variable.parse(key, serializedValue);
            return parsedValue;
        });
    },
    serialize: function (parsedDictionary) {
        return (0, typed_primitives_1.objectMap)(definition, function (key, variable) {
            var parsedValue = parsedDictionary[key];
            var serializedValue = variable.serialize(parsedValue);
            return serializedValue;
        });
    }
}); };
exports.Dictionary = Dictionary;
var intersection = function (d1, d2) { return (0, exports.Dictionary)(Object.assign({}, d1.definition, d2.definition)); };
exports.intersection = intersection;
//# sourceMappingURL=index.js.map